export default __webpack_public_path__ + "static/media/greenpant.535bb8e8.jpg";